import {
  FETCH_NEXT_BOOKING_REQUEST,
  FETCH_NEXT_BOOKING_SUCCESS,
  FETCH_NEXT_BOOKING_FAILURE
} from './actions';

const initialState = {
  nextBookingId: null
};

export default function bookingsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NEXT_BOOKING_REQUEST:
    case FETCH_NEXT_BOOKING_FAILURE:
      return { ...state, nextBookingId: null };
    case FETCH_NEXT_BOOKING_SUCCESS:
      return { ...state, nextBookingId: action.payload.result };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/bookings/reducer.js